



export const compliance = (bugId) => { return `compliance/${bugId}/tags`}
export const getWorkItemTags = (bugId) => { return `workitem/${bugId}/tags` }
export const setKIRUpdates = (bugId) => { return `kir/${bugId}` }

export const urls = {
    newBaseUrl : `https://wsd-azdevopsautomation.azurewebsites.net/api/`,
    oldBaseUrl: `https://compliance-service.azurewebsites.net/api/`,
    getWorkItemTags: getWorkItemTags,
    setKIRUpdates: setKIRUpdates,
    compliance: compliance
} 